import * as React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { defineMessage, useIntl } from 'react-intl';
import { TextLink } from '@foundershub/components';

interface Props {
  id?: string;
}

export function SkipToMain({ id = 'main' }: Props) {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <TextLink href={`#${id}`} className={classes.root}>
      {intl.formatMessage(skipLabel)}
    </TextLink>
  );
}

const skipLabel = defineMessage({
  defaultMessage: 'Skip to main content',
  description: 'accessible skip link',
});

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '50',
    backgroundColor: tokens.colorNeutralBackground1,
    zIndex: 9999,
    transform: 'translateY(-1000%)',
    ...shorthands.transition('transform', '0.2s'),
    ...shorthands.padding(tokens.spacingVerticalL),
    boxShadow: tokens.shadow8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase500,
    ':focus': {
      transform: 'translateY(0)',
    },
  },
});
